<template>
    <Card class="barchartapp shadow028025" shadow :bordered="false" style="box-shadow: 0 2px 3px rgba(0, 0, 0, 0.11);">
        <div style="position:relative; padding-top:20px;" @touchend.stop.prevent="hiddenTooltip()">
            <div class="barchartapp-content">
                <h4>{{$t('a_allDayWorkStatus')}}</h4>
                <ul>
                    <li>
                        <p class="circle bg-green"></p>
                        <p>{{$t('run')}}</p>
                    </li>
                    <li>
                        <p class="circle bg-yellow"></p>
                        <p>{{$t('stby')}}</p>
                    </li>
                    <li>
                        <p class="circle bg-red"></p>
                        <p>{{$t('alarm')}}</p>
                    </li>
                    <li>
                        <p class="circle bg-grey"></p>
                        <p>{{$t('stop')}}</p>
                    </li>
                    <li>
                        <p class="circle bg-white"></p>
                        <p>{{$t('off')}}</p>
                    </li>
                </ul>
            </div>
            <div class="barchartapp-canvas">
                <div id="barChartContainerApp" ref="barChartApp"></div>
            </div>
            <div v-if="tooltip" @mouseleave="hiddenSelf">
                <div ref="tooltip" v-if="toolExpand==false" class="tooltip" :style="{left:tooltipLeft+'px'}">
                    <h4>
                        <Icon type="md-time" style="margin-right:5px;"/>
                        {{tooltipTime}}
                    </h4>
                    <div style="display:flex;justify-content:space-around;padding-top: 10px;font-size:14px;">
                        <div style="display:flex;align-items: center;">
                            <p class="circle" :style="{backgroundColor: tooltipStatus.color}"></p>
                            <p>{{tooltipStatus.name}}</p>
                        </div>
                        <p>{{tooltipRange}}</p>
                    </div>
                    <div class="arrow" :style="{left: tooltipLeftArrow+'px'}">
                        <b class="bottom">
                            <i class="bottom-arrow1"></i>
                            <i class="bottom-arrow2"></i>
                        </b>
                    </div>
                </div>
                <div ref="tooltip" v-else class="tooltip" :style="{left:toolExpandLeft+'px'}" style="width:300px;padding:5px 0 0;">
                    <Magnifier :data="statusAndTime24" :expandURL="expandURL" :MousePx="MousePx" :startTime="startTime" :baseUnit="Unit" @recodeUrl="recodeUrl"></Magnifier>
                    <div class="arrow" :style="{left: toolExpandLeftArrow+'px'}">
                        <b class="bottom">
                            <i class="bottom-arrow1"></i>
                            <i class="bottom-arrow2"></i>
                        </b>
                    </div>
                </div>
            </div>
        </div>
        <div class="barchartapp-table">
            <Table border :columns="tableColumns" :data="divideWorkInfomation" height="538"></Table>
        </div>
    </Card>
</template>
<script>
import BarChart from '@/libs/barChart.js';
import Magnifier from './magnifier.vue';
import Axios from 'axios';
import AxiosUrl from '@/axiosurl.js';
import Moment from 'moment';

export default {
    components: { Magnifier },
    props: ['gid', 'width'],
    data() {
        var tableColumns = [
            {
                renderHeader: (h, params) => {
                    return h('span', {}, this.$t('a_workClass'));
                },
                align: 'center',
                width: 50,
                key: 'name'
            },
            {
                renderHeader: (h, params) => {
                    return h('span', {}, this.$t('a_status'));
                },
                align: 'center',
                width: 50,
                key: 'status',
                render: (h, params) => {
                    return h('ul', [
                        h(
                            'li',
                            {
                                class: ['tableli', 'tableli-border']
                            },
                            params.row.status[0]
                        ),
                        h(
                            'li',
                            {
                                class: ['tableli', 'tableli-border']
                            },
                            params.row.status[1]
                        ),
                        h(
                            'li',
                            {
                                class: ['tableli', 'tableli-border']
                            },
                            params.row.status[2]
                        ),
                        h(
                            'li',
                            {
                                class: ['tableli', 'tableli-border']
                            },
                            params.row.status[3]
                        ),
                        h(
                            'li',
                            {
                                class: 'tableli'
                            },
                            params.row.status[4]
                        )
                    ]);
                }
            },
            {
                title: '0 -- 100',
                align: 'center',
                key: 'table',
                render: (h, params) => {
                    return h('ul', [
                        h(
                            'li',
                            {
                                class: ['tableli', 'tableli-border']
                            },
                            [
                                h('p', {
                                    style: {
                                        position: 'absolute',
                                        left: params.row.table[0].left,
                                        width: params.row.table[0].width,
                                        backgroundColor: '#009900',
                                        height: '20px'
                                    }
                                })
                            ]
                        ),
                        h(
                            'li',
                            {
                                class: ['tableli', 'tableli-border']
                            },
                            [
                                h('p', {
                                    style: {
                                        position: 'absolute',
                                        left: params.row.table[1].left,
                                        width: params.row.table[1].width,
                                        backgroundColor: '#C6C013',
                                        height: '20px'
                                    }
                                })
                            ]
                        ),
                        h(
                            'li',
                            {
                                class: ['tableli', 'tableli-border']
                            },
                            [
                                h('p', {
                                    style: {
                                        position: 'absolute',
                                        left: params.row.table[2].left,
                                        width: params.row.table[2].width,
                                        backgroundColor: '#EF2917',
                                        height: '20px'
                                    }
                                })
                            ]
                        ),
                        h(
                            'li',
                            {
                                class: ['tableli', 'tableli-border']
                            },
                            [
                                h('p', {
                                    style: {
                                        position: 'absolute',
                                        left: params.row.table[3].left,
                                        width: params.row.table[3].width,
                                        backgroundColor: '#898989',
                                        height: '20px'
                                    }
                                })
                            ]
                        ),
                        h(
                            'li',
                            {
                                class: 'tableli'
                            },
                            [
                                h('p', {
                                    style: {
                                        position: 'absolute',
                                        left: params.row.table[4].left,
                                        width: params.row.table[4].width,
                                        backgroundColor: '#eeeeee',
                                        height: '20px'
                                    }
                                })
                            ]
                        )
                    ]);
                }
            },
            {
                title: '%',
                align: 'center',
                width: 60,
                key: 'scale',
                render: (h, params) => {
                    return h('ul', [
                        h(
                            'li',
                            {
                                class: ['tableli', 'tableli-border']
                            },
                            params.row.scale[0]
                        ),
                        h(
                            'li',
                            {
                                class: ['tableli', 'tableli-border']
                            },
                            params.row.scale[1]
                        ),
                        h(
                            'li',
                            {
                                class: ['tableli', 'tableli-border']
                            },
                            params.row.scale[2]
                        ),
                        h(
                            'li',
                            {
                                class: ['tableli', 'tableli-border']
                            },
                            params.row.scale[3]
                        ),
                        h(
                            'li',
                            {
                                class: 'tableli'
                            },
                            params.row.scale[4]
                        )
                    ]);
                }
            },
            {
                renderHeader: (h, params) => {
                    return h('span', {}, this.$t('a_usedTime'));
                },
                align: 'center',
                width: 75,
                key: 'totaltime',
                render: (h, params) => {
                    return h('ul', [
                        h(
                            'li',
                            {
                                class: ['tableli', 'tableli-border']
                            },
                            params.row.totaltime[0]
                        ),
                        h(
                            'li',
                            {
                                class: ['tableli', 'tableli-border']
                            },
                            params.row.totaltime[1]
                        ),
                        h(
                            'li',
                            {
                                class: ['tableli', 'tableli-border']
                            },
                            params.row.totaltime[2]
                        ),
                        h(
                            'li',
                            {
                                class: ['tableli', 'tableli-border']
                            },
                            params.row.totaltime[3]
                        ),
                        h(
                            'li',
                            {
                                class: 'tableli'
                            },
                            params.row.totaltime[4]
                        )
                    ]);
                }
            },
            {
                renderHeader: (h, params) => {
                    return h('span', {}, this.$t('a_statusCount'));
                },
                align: 'center',
                width: 50,
                key: 'statusCount',
                render: (h, params) => {
                    return h('ul', [
                        h(
                            'li',
                            {
                                class: ['tableli', 'tableli-border']
                            },
                            params.row.statusCount[0]
                        ),
                        h(
                            'li',
                            {
                                class: ['tableli', 'tableli-border']
                            },
                            params.row.statusCount[1]
                        ),
                        h(
                            'li',
                            {
                                class: ['tableli', 'tableli-border']
                            },
                            params.row.statusCount[2]
                        ),
                        h(
                            'li',
                            {
                                class: ['tableli', 'tableli-border']
                            },
                            params.row.statusCount[3]
                        ),
                        h(
                            'li',
                            {
                                class: 'tableli'
                            },
                            params.row.statusCount[4]
                        )
                    ]);
                }
            },
            {
                renderHeader: (h, params) => {
                    return h('span', {}, this.$t('a_DataCount'));
                },
                align: 'center',
                width: 135,
                key: 'totaltime',
                render: (h, params) => {
                    return h('ul', [
                        h(
                            'li',
                            {
                                class: ['tableli', 'tableli-border']
                            },
                            `${this.$t('useRate')}: ${params.row.count.oee}`
                        ),
                        h(
                            'li',
                            {
                                class: ['tableli', 'tableli-border']
                            },
                            `${this.$t('powerNum')}: ${params.row.count.power}`
                        ),
                        h(
                            'li',
                            {
                                class: ['tableli', 'tableli-border']
                            },
                            `${this.$t('a_pdTarget')}: ${params.row.count.product}`
                        ),
                        h(
                            'li',
                            {
                                class: ['tableli', 'tableli-border']
                            },
                            `${this.$t('a_finishNm')}: ${params.row.count.finishRate} (90.0%)`
                        ),
                        h(
                            'li',
                            {
                                class: 'tableli'
                            },
                            `${this.$t('a_rejectNm')}: ${params.row.count.reject} (5.2%)`
                        )
                    ]);
                }
            }
        ];
        return {
            Unit: 10,
            data: {}, //请求出来的所有数据
            origin: [], //获取出来的参数原始数组
            statusAndTime24: [], //一整天的状态和次数数组，status time 保存24小时的状态
            divideWork: [], //24小时分工的对象数组   name：S1，start：2000，end：3000（秒）
            divideWorkInfomation: [], //处理分工后的详细数据
            startTime: 0, //第一班的开始时间
            tableColumns,
            tooltip: false,
            tooltipTime: '', //tooltip显示的时间
            tooltipRange: '', //tooltip显示的排班
            tooltipStatus: {}, //tooltip显示的工作状态
            tooltipLeft: 0, //tooltip的位置
            toolExpandLeft: 0, //toolExpand的位置
            tooltipLeftArrow: 0, //tooltip下面三角符号的位置
            toolExpandLeftArrow: 0, //toolExpand下面三角符号的位置
            toolExpand: false, //是否显示放大镜
            expandURL: '',
            MousePx: 50 //鼠标移动后，所在的px值
        };
    },
    created() {
        Axios.get(AxiosUrl.group.singlecount, {
            params: {
                gid: this.gid
            }
        }).then(res => {
            if (res.data.code == 200) {
                this.$emit('on-update-data', res.data.data);
                this.data = res.data.data;
                this.initChart();
            } else {
                console.log(res.data.msg);
            }
        });
    },
    methods: {
        //处理数据并画图
        initChart() {
            //整理读取到的状态数据
            var time_status = this.data.time_status;
            let PresentTimeToStart = time_status.length * this.Unit;
            for (let i = time_status.length; i < 8641; i++) {
                time_status.push(5);
            }
            this.origin = time_status;
            let statusAndTime = [];
            var obj1 = new Object({
                status: this.origin[0],
                number: 1
            });
            var length = this.origin.length;
            for (let i = 1; i < length; i++) {
                if (this.origin[i] == obj1.status) {
                    obj1.number++;
                } else {
                    statusAndTime.push(obj1);
                    obj1 = new Object({
                        status: this.origin[i],
                        number: 1
                    });
                }
            }
            statusAndTime.push(obj1); //因为最后必定会有数据，所以要再加入数组一次
            this.statusAndTime24 = statusAndTime;
            //整理排班情况 把时间转换成秒
            var wt_status = this.data.wt_status;
            var divideWork = [];
            wt_status.forEach(item => {
                var obj1 = {
                    name: item.wt_name,
                    start: this.$util.toSeconds(item.wt_start),
                    end: this.$util.toSeconds(item.wt_end),
                    wt_id: item.wt_id,
                    run: item.run,
                    stby: item.stby,
                    alarm: item.alarm,
                    stop: item.stop,
                    off: item.off,
                    power: item.power,
                    run_count: item.run_count,
                    stby_count: item.stby_count,
                    alarm_count: item.alarm_count,
                    stop_count: item.stop_count,
                    off_count: item.off_count
                };
                divideWork.push(obj1);
            });
            this.divideWork = divideWork;
            this.startTime = this.divideWork[0].start;
            //开始画图
            new BarChart(
                {
                    container: 'barChartContainerApp',
                    data: this.statusAndTime24,
                    // width: 1540,
                    width: this.width <= 700 ? window.innerWidth - 32 : this.width - 32,
                    height: 125,
                    moreWidth: 2,
                    unit: this.Unit,
                    divideWork: this.divideWork
                },
                this.showTooltip,
                this.hiddenTooltip,
                this.tooltipContent,
                this.dclickChart
            );
            //整理table中的数据
            var origin = this.startTime / this.Unit;
            this.divideWork.forEach(item => {
                var obj1 = new Object({
                    name: item.name,
                    status: [this.$t('run'), this.$t('stby'), this.$t('alarm'), this.$t('stop'), this.$t('off')]
                });
                let runPercent = 0,
                    stbyPercent = 0,
                    alarmPercent = 0,
                    stopPercent = 0,
                    offPercent = 0;
                var allData = item.run + item.stby + item.alarm + item.stop + item.off;
                if (allData != 0) {
                    runPercent = (item.run / allData) * 100;
                    stbyPercent = (item.stby / allData) * 100;
                    alarmPercent = (item.alarm / allData) * 100;
                    stopPercent = (item.stop / allData) * 100;
                    offPercent = (item.off / allData) * 100;
                }
                obj1.scale = [runPercent.toFixed(1) + '%', stbyPercent.toFixed(1) + '%', alarmPercent.toFixed(1) + '%', stopPercent.toFixed(1) + '%', offPercent.toFixed(1) + '%'];
                obj1.statusCount = [item.run_count, item.stby_count, item.alarm_count, item.stop_count, item.off_count];
                let allTime = item.end - item.start;
                let computingTime = 0;
                if (PresentTimeToStart <= allTime) {
                    computingTime = PresentTimeToStart;
                } else {
                    computingTime = allTime;
                    PresentTimeToStart -= allTime;
                }
                let runTime = this.$util.formatTimeRange((runPercent * computingTime) / 100);
                let stbyTime = this.$util.formatTimeRange((stbyPercent * computingTime) / 100);
                let alarmTime = this.$util.formatTimeRange((alarmPercent * computingTime) / 100);
                let stopTime = this.$util.formatTimeRange((stopPercent * computingTime) / 100);
                let offTime = this.$util.formatTimeRange((offPercent * computingTime) / 100);
                obj1.totaltime = [runTime, stbyTime, alarmTime, stopTime, offTime];
                obj1.table = [
                    {
                        left: 0 + '%',
                        width: runPercent.toFixed(1) + '%'
                    },
                    {
                        left: runPercent.toFixed(1) + '%',
                        width: stbyPercent.toFixed(1) + '%'
                    },
                    {
                        left: (stbyPercent + runPercent).toFixed(1) + '%',
                        width: alarmPercent.toFixed(1) + '%'
                    },
                    {
                        left: (alarmPercent + stbyPercent + runPercent).toFixed(1) + '%',
                        width: stopPercent.toFixed(1) + '%'
                    },
                    {
                        left: (stopPercent + alarmPercent + stbyPercent + runPercent).toFixed(1) + '%',
                        width: offPercent.toFixed(1) + '%'
                    }
                ];
                obj1.count = {
                    oee: this.run(item),
                    power: this.kwh(item),
                    product: 100,
                    finishRate: 95,
                    reject: 5
                };
                this.divideWorkInfomation.push(obj1);
            });
        },
        //控制显示隐藏Tooltip
        showTooltip(px) {
            //tooltip
            if (px < 90) {
                this.tooltipLeft = this.$refs.barChartApp.offsetLeft - 10;
                this.tooltipLeftArrow = px;
            } else if (px > window.innerWidth - 122) {
                this.tooltipLeft = this.$refs.barChartApp.offsetLeft + window.innerWidth - 32 - 200 + 10;
                this.tooltipLeftArrow = px - window.innerWidth + 216;
            } else {
                this.tooltipLeft = this.$refs.barChartApp.offsetLeft + px - 10 - 90;
                this.tooltipLeftArrow = 93;
            }
            //toolExpand
            // if (px < 190) {
            //     this.toolExpandLeft = this.$refs.barChart.offsetLeft + 50 - 10;
            //     this.toolExpandLeftArrow = px - 47;
            // } else if (px > 1350) {
            //     this.toolExpandLeft = this.$refs.barChart.offsetLeft + 1540 - 50 - 300 + 10;
            //     this.toolExpandLeftArrow = px - 1440 + 192 + 40;
            // } else {
            //     this.toolExpandLeft = this.$refs.barChart.offsetLeft + px - 10 - 140;
            //     this.toolExpandLeftArrow = 143;
            // }
            this.tooltip = true;
            this.MousePx = px;
        },
        //控制隐藏Tooltip
        hiddenTooltip(clientX, clientY) {
            this.tooltip = false;
        },
        //tooltip显示的内容
        tooltipContent(px, time, classes, status) {
            //tooltip
            if (px < 90) {
                this.tooltipLeftArrow = px;
            } else if (px > window.innerWidth - 122) {
                this.tooltipLeft = this.$refs.barChartApp.offsetLeft + window.innerWidth - 32 - 200 + 10;
                this.tooltipLeftArrow = px - window.innerWidth + 216;
            } else {
                this.tooltipLeft = this.$refs.barChartApp.offsetLeft + px - 10 - 90;
            }
            this.tooltipTime = time;
            this.tooltipRange = classes;
            var statusAndColor = [{ name: this.$t('stop'), color: '#898989' }, { name: this.$t('run'), color: '#009900' }, { name: this.$t('stby'), color: '#C6C013' }, { name: this.$t('alarm'), color: '#EF2917' }, { name: this.$t('off'), color: '#eeeeee' }, { name: this.$t('a_noStart'), color: '#fff' }];
            this.tooltipStatus = statusAndColor[status];
            // //toolExpand
            // if (px < 190) {
            //     this.toolExpandLeftArrow = px - 47; //50因为canvas左侧有50边距
            // } else if (px > 1350) {
            //     this.toolExpandLeft = this.$refs.barChart.offsetLeft + 1540 - 50 - 300 + 10;
            //     this.toolExpandLeftArrow = px - 1440 + 192 + 40;
            // } else {
            //     this.toolExpandLeft = this.$refs.barChart.offsetLeft + px - 10 - 140;
            // }
            this.MousePx = px;
        },
        dclickChart(px, isExpand) {
            this.toolExpand = isExpand;
            this.showTooltip(px); //不执行双击会有bug
            this.MousePx = px;
        },
        //tooltip关闭自己
        hiddenSelf(evt) {
            this.tooltip = false;
        },
        //记录放大镜的URL
        recodeUrl(value) {
            this.expandURL = value;
        },
        run(item) {
            let total = item.run + item.stby + item.alarm + item.stop + item.off;
            if (total > 0) {
                return ((item.run / total) * 100).toFixed(1) + '%';
            }
            return '0.0%';
        },
        finish(item) {
            if (item.total > 0) {
                return ((item.finish / item.total) * 100).toFixed(1) + '%';
            }
            return '0.0%';
        },
        kwh(item) {
            if (item.power > 0) {
                return (item.power / 10).toFixed(1) + 'kwh';
            }
            return '0.0kwh';
        }
    }
};
</script>
<style lang="less">
.barchartapp {
    .barchartapp-content {
        padding: 15px 0;
        width: 100%;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        h4 {
            font-size: 16px;
        }
        ul {
            display: flex;
            li {
                display: flex;
                align-items: center;
                margin-left: 15px;
            }
        }
    }
    .circle {
        width: 14px;
        height: 14px;
        border-radius: 50%;
        margin-right: 5px;
    }
    .barchartapp-canvas {
        width: 100;
        margin: 0 auto;
    }
    .tooltip {
        position: absolute;
        top: 0px;
        width: 200px;
        height: 85px;
        padding: 15px 0 0;
        border: 1px solid #777;
        border-radius: 3px;
        // font-size: 0;
        background-color: #fff;
        z-index: 3;
        box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.33);
        text-align: center;
        .arrow {
            position: absolute;
            bottom: 0px;
            pointer-events: none;
        }
        .bottom-arrow1,
        .bottom-arrow2 {
            position: absolute;
            z-index: 5;
            /*兼容ie8-*/
            border-bottom: 7px transparent dashed;
            border-left: 7px transparent dashed;
            border-right: 7px transparent dashed;
            border-top: 7px #fff solid;
            overflow: hidden;
        }
        .bottom-arrow1 {
            top: 1px;
            /*重要*/
            border-top: 7px #333 solid;
        }
        .bottom-arrow2 {
            border-top: 7px #fff solid;
        }
    }
    .barchartapp-table {
        padding-top: 30px;
        .tableli {
            width: 100%;
            text-align: center;
            height: 40px;
            line-height: 20px;
            padding: 10px;
            position: relative;
        }
        .tableli-border {
            border-bottom: 1px solid #e8eaec;
        }
        .ivu-table-cell {
            padding: 0;
        }
    }
}
</style>




// WEBPACK FOOTER //
// src/views/oeetableapp/components/barChart.vue